import React from 'react';
import { Tag, Heading, Lead, PageHero, Section, BtnPrimary } from '../components/UI';
import styles from './Staffing.module.css';

const SERVICES = [
  {
    icon: '🏢', t: 'HR Solutions',
    d: 'Specialized HR services to clients in India across different sectors — structured, reliable, and tailored to your industry\'s unique requirements. We handle everything from HR policy creation to compliance management.',
  },
  {
    icon: '🤝', t: 'Staffing Services',
    d: 'We have built a solid reputation in providing the highest quality support to clients and candidates. From consulting and right-to-hire positions to direct placements, we supply candidates to locations in the US and India.',
  },
  {
    icon: '⚙️', t: 'Outsourcing Services',
    d: 'We are a services company in the BPO industry providing back-office services to our various clients. Our teams handle data entry, customer support, finance & accounting, and other back-office functions cost-effectively.',
  },
];

const PROCESS = [
  { n: '01', t: 'Requirement Gathering',   d: 'Deep dive into your staffing requirements, job roles, culture, and timelines.' },
  { n: '02', t: 'Talent Sourcing',          d: 'Leverage our extensive database and networks to source top-quality candidates.' },
  { n: '03', t: 'Screening & Assessment',   d: 'Rigorous interviews, skills tests, and background verification for every candidate.' },
  { n: '04', t: 'Shortlisting',             d: 'Present a curated list of qualified candidates aligned to your specific needs.' },
  { n: '05', t: 'Interview Coordination',   d: 'Manage scheduling, feedback collection, and candidate communication throughout.' },
  { n: '06', t: 'Onboarding Support',       d: 'Ensure smooth onboarding and follow-up to guarantee successful integration.' },
];

const TYPES = [
  { t: 'Permanent Staffing',    d: 'Full-time placements for long-term roles that drive core business functions.' },
  { t: 'Temporary Staffing',    d: 'Flexible workforce for project-based, seasonal, or short-term requirements.' },
  { t: 'Contract Staffing',     d: 'Skilled professionals on defined contracts with flexible renewal options.' },
  { t: 'Right-to-Hire',         d: 'Try before you hire — contract positions that can convert to permanent roles.' },
  { t: 'Executive Search',      d: 'Senior and C-suite leadership placement with discreet headhunting services.' },
  { t: 'IT Staffing',           d: 'Specialized technology professionals for IT projects across all domains.' },
];

export default function Staffing() {
  return (
    <>
      <PageHero
        tag="HR & Staffing Services"
        title="End-to-End Talent Solutions for India & USA"
        subtitle="We support employers across India and the USA with staffing solutions for permanent, temporary, and contract roles — helping organizations hire faster and scale efficiently."
      />

      {/* ── Core Services ──────────────────────────────────────── */}
      <Section variant="paper">
        <Tag>Our Services</Tag>
        <Heading>Three Pillars of HR Excellence</Heading>
        <div className={styles.servicesGrid}>
          {SERVICES.map((svc, i) => (
            <div key={i} className={styles.svcCard}>
              <div className={styles.svcIcon}>{svc.icon}</div>
              <h3 className={styles.svcTitle}>{svc.t}</h3>
              <p className={styles.svcDesc}>{svc.d}</p>
            </div>
          ))}
        </div>
      </Section>

      {/* ── Staffing Types ─────────────────────────────────────── */}
      <Section variant="white">
        <Tag>Staffing Models</Tag>
        <Heading>Flexible Staffing for Every Need</Heading>
        <Lead>Whether you need immediate hires or long-term workforce planning, we have the right model.</Lead>
        <div className={styles.typesGrid}>
          {TYPES.map((type, i) => (
            <div key={i} className={styles.typeCard}>
              <h4 className={styles.typeTitle}>{type.t}</h4>
              <p className={styles.typeDesc}>{type.d}</p>
            </div>
          ))}
        </div>
      </Section>

      {/* ── Process ────────────────────────────────────────────── */}
      <Section variant="ink">
        <Tag light>Our Approach</Tag>
        <Heading light>Structured Staffing Process</Heading>
        <Lead light>A proven, rigorous methodology that ensures every candidate is the right fit.</Lead>
        <div className={styles.processGrid}>
          {PROCESS.map((step, i) => (
            <div key={i} className={styles.processStep}>
              <div className={styles.processNum}>{step.n}</div>
              <h4 className={styles.processTitle}>{step.t}</h4>
              <p className={styles.processDesc}>{step.d}</p>
            </div>
          ))}
        </div>
      </Section>

      {/* ── For Employers & Jobseekers ─────────────────────────── */}
      {/* <Section variant="paper">
        <div className={styles.audienceGrid}>
          <div className={styles.audienceCard}>
            <div className={styles.audienceTag}>For Employers</div>
            <h3 className={styles.audienceTitle}>Scale Your Team with Confidence</h3>
            <p className={styles.audienceDesc}>
              We work closely with you to identify workforce gaps and deliver highly qualified
              candidates who align with your technical, operational, and cultural needs —
              ensuring a strong, efficient, and future-ready workforce.
            </p>
            <ul className={styles.audienceList}>
              {['Dedicated account manager for your hiring needs',
                'Access to a diverse, pre-screened talent pool',
                'Fast turnaround with strong SLA commitments',
                'Deep expertise across multiple industries',
              ].map((item, i) => (
                <li key={i}><span>✓</span>{item}</li>
              ))}
            </ul>
            <BtnPrimary to="/contact" style={{ marginTop: '1.8rem' }}>
              Post a Requirement →
            </BtnPrimary>
          </div>

          <div className={`${styles.audienceCard} ${styles.audienceCardDark}`}>
            <div className={styles.audienceTag} style={{ color: 'rgba(255,255,255,0.4)' }}>For Jobseekers</div>
            <h3 className={`${styles.audienceTitle}`} style={{ color: '#fff' }}>
              Find Your Next Opportunity
            </h3>
            <p className={styles.audienceDesc} style={{ color: 'rgba(255,255,255,0.58)' }}>
              We assist jobseekers by connecting them with verified opportunities across
              multiple industries in India and the USA. From job matching and interview
              coordination to onboarding support, we guide you through every stage.
            </p>
            <ul className={`${styles.audienceList} ${styles.audienceListLight}`}>
              {['Access verified job openings across industries',
                'Personalized job matching based on your skills',
                'End-to-end interview preparation & support',
                'Onboarding guidance after placement',
              ].map((item, i) => (
                <li key={i}><span>→</span>{item}</li>
              ))}
            </ul>
            <BtnPrimary to="/contact" style={{ marginTop: '1.8rem' }}>
              Submit Your Resume →
            </BtnPrimary>
          </div>
        </div>
      </Section> */}

      {/* ── Industries ─────────────────────────────────────────── */}
      <Section variant="white" style={{ textAlign: 'center' }}>
        <Tag>Sectors We Cover</Tag>
        <Heading>Industries We Serve</Heading>
        <div className={styles.indRow}>
          {['🏥 Healthcare','🛒 E-commerce','🎓 Education','💰 Finance','🚚 Logistics','🏠 Real Estate'].map((ind, i) => (
            <div key={i} className={styles.indChip}>{ind}</div>
          ))}
        </div>
        <BtnPrimary to="/contact" style={{ marginTop: '2.5rem' }}>
          Talk to Our Staffing Team
        </BtnPrimary>
      </Section>
    </>
  );
}
